export default {
    // python: {
    //     minAge: 13,
    //     maxAge: 60,
    //     name: "Python и data science",
    //     subtitle: "",
    //     price: "400 руб занятие",
    //     duration: "1.5 час",
    //     quantity: "1 раз в неделю",
    //     inCourse: "3 блока по 12 занятий",
    //     total: "Знакомство с python и его применением в Data Science, Machine Learning, Deep Learning",
    //     intro: "Анализ  обработки и представления данных, в том числе с применением искусственного интеллекта ",
    //     discription: "Python, машинное обучение, нейронные сети ",
    //     category: ["code"],
    //     img: "python.jpg",
    //     teacher: "Илья Уткин",
    //     skills:"<span>Программист VK<br> Data Scientist</span>",
    //     age:"25 лет",
    //     avatar:"ilya.webp",
    // },


    gArt: {
        minAge: 11,
        maxAge: 60,
        name: "Цифровая живопись",
        subtitle: "Krita",
        price: "250 руб занятие",
        duration: "1 час",
        quantity: "2 раз в неделю",
        inCourse: "3 блока по 8 занятий",
        total: "фэнтези натюрморт, фантастический дом, персонаж",
        intro: "Создание изображений, за счёт использования компьютерных имитаций традиционных инструментов художника.",
        discription: "1 Блок - Изучение простых предметов. Изучение классической живописи, (Тень, Свет, Цвет, Композиция) 2 Блок - Концепт фантастического дома, пейзажа, комнаты. Изучение перспективы, композиции, построения.3 Блок - Концепт персонажа. Изучение основ анатомии, построения, изучение женского и мужского лица. ",
        category: ["grathics"],
        img: "uca.jpg",
        teacher: "Юка Синицына",
        skills:"<span>Художник-иллюстратор <br> преподаватель</span>",
        age:"29 лет",
        avatar:"uka.webp",
    },

    java: {
        minAge: 13,
        maxAge: 60,
        name: "Java",
        subtitle: "Eclipse",
        price: "400 руб занятие",
        duration: "1.5 часа",
        quantity: "1 раз в неделю",
        inCourse: "4 модуля по 12 занятий",
        total: "Несколько игр за курс",
        intro: "Универсальный язык, который можно использовать почти в любых целях. На java делают игры, мобильные приложения и многое другое",
        discription: "Познакомитесь со средой разработки Eclipse и основными элементами разработки программы,с правилами создания программы на языке Java и ее структурой, с синтаксисом языка программирования Java,особенностями написания инструкций.",
        category: ["code"],
        img: "java.jpg",
        teacher: "Сергей Копысов",
        skills:"Программист",
        age:"50 лет",
        avatar:"sergey.webp",

    },
    web: {
        minAge: 13,
        maxAge: 60,
        name: "Web разработка",
        subtitle: "Visual Studio Code",
        price: "400 руб занятие",
        duration: "1.5 часа",
        quantity: "1 раз в неделю",
        inCourse: "3 модуля по 12 занятий",        
        total: "Игра, сайт, приложение",
        intro: "Разработка сайтов и приложений для компьютеров и телефонов.",
        discription: "Знакомимся с HTML, CSS, JavaScript, Jquery, Bootstrap, NodeJS, MongoDB, VueJS  ",
        category: ["code"],
        img: "web.jpg",
        teacher: "Роман Грачев",
        skills:"Экономист, юрист, программист",
        age:"47 лет",
        avatar:"roman.webp",
    },

    scratch: {
        minAge: 9,
        maxAge: 12,
        name: "Scratch",
        subtitle: "игры, мультфильмы, открытки, приложения",
        price: "250 руб занятие",
        duration: "45 минут",
        quantity: "1 раз в неделю",
        inCourse: "без ограничений",
        total: "Результат на каждом занятии",
        intro: "Это лего в мире программирования. Это ваш первый язык.",
        discription: "Скретч  — визуальная событийно-ориентированная среда программирования для обучения школьников младших и средних классов. С помощью Скретч вы можете программировать собственные интерактивные истории, игры и анимацию.",
        category: ["grathics", "code"],
        img: "scratch.jpg",
        teacher: "Наталья Ильина",
        skills:"Преподаватель",
        age:"25 лет",
        avatar:"natalya.webp",
    },

    // g3d: {
    //     minAge: 13,
    //     maxAge: 60,
    //     name: "3d моделирование",
    //     subtitle: "Blender",
    //     price: "400 руб занятие",
    //     duration: "1.5 часа",
    //     quantity: "1 раз в неделю",
    //     inCourse: "12 занятий",
    //     total: "Предмет интерьера",
    //     intro: "3D-моделирование -это создание моделей для игр, сайтов, фильмов, промышленности, интерьера и архитектуры.",
    //     discription: "Основы работы с Blender. Основы 3d моделирования: твердые предметы, ткани, свет, тень, цвет, текстуры.",
    //     category: ["grathics"],
    //     img: "3d.jpg",
    //     teacher: "Александр Хаймин",
    //     skills:"3D моделист, предприниматель",
    //     age:"34 года",
    //     avatar:"aleksandr.webp",
    // },
    // gProto: {
    //     minAge: 14,
    //     maxAge: 60,
    //     name: "Дизайн и прототипирование",
    //     subtitle: "Figma, Inkscape, Gimp",
    //     price: "400 руб занятие",
    //     duration: "1.5 часа",
    //     quantity: "1 раз в неделю",
    //     inCourse: "2 блока по 12 занятий",
    //     total: "Прототип сайта, приложения",
    //     intro: "Прототипирование — это создание макета сайта, приложения. На основе макета программисты делают сайт, приложение",
    //     discription: "Прототипирование интерфейсов — один из ранних этапов создания продукта. Прототип облегчает общение между разработчиками, конкретизирует техзадание и помогает в планировании дальнейшей работы.",
    //     category: ["grathics"],
    //     img: "proto.jpg",
    //     teacher: "Валентин Наговицын",
    //     skills:"Дизайнер, менеджер",
    //     age:"29 лет",
    //     avatar:"valentin.webp",
    // },
}